import React, { useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import _ from 'lodash';
import { deleteEvent, fetchEventsList } from 'gqlQueries/promoRecommendation';

const errorMessage: string = 'Something went wrong!';

function useDeleteEvent({ onComplete }: { onComplete: Function }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);

    const [deletePlanEvent, { data: eventsListData, loading: eventsListDataLoading, error: eventsListDataError }] =
        useMutation(deleteEvent, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            onComplete();
            //const featureGroup = payload;
            //if data present parse it
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,

        deletePlanEvent: (variables: any) => {
            setError(null);
            setLoading(true);
            deletePlanEvent(variables);
        },
    };
}

export { useDeleteEvent };
